import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

export const CityFilter = ({ cities, selectedCity, onCityChange }) => {
  return (
    <div data-testid="city-filter">
      <Select 
        value={selectedCity || "all"} 
        onValueChange={(value) => onCityChange(value === "all" ? null : value)}
      >
        <SelectTrigger 
          className="w-[200px] bg-transparent border-white/20 text-white rounded-none focus:ring-[var(--primary)]"
          data-testid="city-filter-trigger"
        >
          <SelectValue placeholder="Todas las ciudades" />
        </SelectTrigger>
        <SelectContent className="bg-[var(--surface)] border-white/10 rounded-none">
          <SelectItem 
            value="all" 
            className="text-white hover:bg-[var(--surface-highlight)] focus:bg-[var(--surface-highlight)] focus:text-white rounded-none"
          >
            Todas las ciudades
          </SelectItem>
          {cities.map((city) => (
            <SelectItem 
              key={city.value} 
              value={city.value}
              className="text-white hover:bg-[var(--surface-highlight)] focus:bg-[var(--surface-highlight)] focus:text-white rounded-none"
              data-testid={`city-option-${city.value}`}
            >
              {city.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default CityFilter;
